import React, { useEffect, useRef } from 'react';
import '../styles/about.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const textLeftRef = useRef(null);
  const textRightRef = useRef(null);

  useEffect(() => {
    // "Technical" (left to right)
    gsap.fromTo(
      textLeftRef.current,
      { x: '-100vw' },
      {
        x: '65vw',
        ease: 'none',
        scrollTrigger: {
          trigger: textLeftRef.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );

    // "Indirect Procurement" (right to left — slightly faster)
    gsap.fromTo(
      textRightRef.current,
      { x: '100vw' },
      {
        x: '-110vw', // more distance = faster scroll
        ease: 'none',
        scrollTrigger: {
          trigger: textRightRef.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  }, []);

  return (
    <section className="about">
      <div className="scroll-text left-scroll" ref={textLeftRef}>
        <h1>Technical</h1>
      </div>
      <div className="scroll-text right-scroll" ref={textRightRef}>
        <h1 className="right-text">
          
          <span className="rotating-and">
            <span className="circle">
              <span className="amp">&</span>
            </span>
          </span>
          Indirect Procurement
        </h1>
      </div>

      <div className="about-content">
        <h2>
          About Me
          <span className="underline"></span>
        </h2>
        <p>
          Dedicated, result-focused and proactive Deputy General Manager of Technical & Indirect Procurement with <span>Sun Pharmaceutical Industries Limited</span>, 17 years of experience developed global purchasing strategies. Nurtured 12+ years of business partnerships, and significantly reduced expenses. Specialises in strategic sourcing, contract management, supplier relationship management with cross-functionality and team collaboration to brainstorm risk mitigation and development solution.
        </p>
      </div>
    </section>
  );
};

export default About;
